<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15oDtME/tc-custom/9780061957710.jpg?1730604184599" alt="This image is the cover for the book Pulse"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pulse
      </h1>
      <p class="bookDescription body article font2">
        <b>A transplant patient unravels the mysterious death of his heart donor in this “greased-lightning thriller from the Pulitzer-winning crime reporter” (<i>Kirkus</i>). </b><br/><br/>If Daniel Alexander had not committed suicide, Frank Douglas would never have lived to see his forty-fifth birthday. Alexander’s heart now beats strong and sure in Douglas’s chest. The donated organ has given the successful Miami businessman a second chance . . . but it gives him no peace.<br/><br/>Disturbed by nagging feelings of guilt, Frank sets out to discover all he can about his benefactor. His search leads him to Rory Alexander—Daniel’s beautiful, enigmatic wife—and to troubling questions about the late man’s affairs. Why, for example, have the profits from Alexander’s business ventures mysteriously vanished? And why is Rory so unshakably certain that her husband was murdered? Pursuing the answers leads Frank into a twisted tale of greed, secrets, and savagery—one that puts his newly grated life in serious peril.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edna  Buchanan
      </h2>
      
      <p class="authorDescription body article">Edna Buchanan knows firsthand that underneath Miami's glistening facade lies a city torn by violence and muddied by corruption, where every moment a crime is waiting to happen. As a Pulitzer Prize-winning crime reporter, Buchanan has exposed the seamier sides of this sun-drenched paradise, then used her more than twenty years of experience to create a dynamic and deadly Miami that vividly comes alive in each of her novels. Especially when the city is seen through the fiercely intense eyes of a tough newspaperwoman named Britt Montero. The author of eleven books, Buchanan has spent time behind bars -- with two serial killers. She lives in Miami, Florida.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publisher
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8d81e60